import React, { useState, useEffect, useRef } from "react";
import { trans } from "../../../helpers/index";
import config from "../../../baseConfig/index";
import { localStorageSetItem } from "../../../storage/index";
import ApiManager from "../../../apiManager/index";
import LanguageList from "../../Fragments/LanguageList";
import ReactNotification from "react-notifications-component";
import ErrorModal from "../../Fragments/ErrorModal";

function Settings(props) {
  const [notificationTypes, setNotificationTypes] = useState({
    sms: false,
    smsDisabled: false,
    mail: false,
    mailDisabled: false,
  });
  const [showErrorModal, setShowErrorModal] = useState(false);
  const isMountedRef = useRef(false);

 const notificationDOMRef = useRef(null);
  useEffect(() => {
    if (props.parentState.switchAccount) {
      setNotificationTypes({
        sms: false,
        smsDisabled: false,
        mail: false,
        mailDisabled: false,
      });
    }
  }, [props.parentState.switchAccount]);

  useEffect(() => {
    isMountedRef.current = true;
    initAsyncCalls(); 

    return () => {
      isMountedRef.current = false; 
    };
  }, []);
  useEffect(() => {
    if (props.parentState.switchAccount) {
      initAsyncCalls();
    }
  }, [props.parentState.switchAccount]);
  const initAsyncCalls = () => {
    ApiManager.getRequest(
      {
        jwt: props.getDecryptedToken(),
      },
      "/notification/settings/get"
    ).then(getNotificationsSuccess, errorCallBack);
  };

  const getNotificationsSuccess = (resolve) => {
    if (!isMountedRef.current) return;

    if (resolve.data.status === "OK" && resolve.data.data) {
      const newTypes = { ...notificationTypes };

      resolve.data.data.notifications.forEach((item) => {
        newTypes[item.type] = true;
      });

      setNotificationTypes(newTypes);
    }
  };

  const errorCallBack = () => {
    setShowErrorModal(true);
  };

  const addNotification = (inMessage, type = "success") => {
    if (!isMountedRef.current) return;

    notificationDOMRef.current.addNotification({
      title: "",
      message: inMessage,
      type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true },
    });
  };

  function changeHandler(checkedValue) {
    setNotificationTypes((prevState) => {
      const newTypes = { ...prevState };
            newTypes[checkedValue] = !newTypes[checkedValue];
      newTypes[checkedValue + "Disabled"] = true;
        const action = newTypes[checkedValue] ? "enable" : "disable";
  
      ApiManager.postRequest(
        {
          _token: props.csrf_token.data,
          jwt: props.getDecryptedToken(),
          type: checkedValue,
          action: action,
        },
        "/notification/settings/update"
      ).then(
        (resolve) => {
          if (!isMountedRef.current) return;
  
          const updatedTypes = { ...newTypes };
          updatedTypes[checkedValue + "Disabled"] = false;
  
          if (resolve.data.status === "OK") {
            setNotificationTypes(updatedTypes);
            addNotification(resolve.data.message);
          } else {
            updatedTypes[checkedValue] = false;
            setNotificationTypes(updatedTypes);
            addNotification(resolve.data.message, "danger");
          }
        },
        (error) => errorCallBack(error)
      );
  
      return newTypes;
    });
  }
  

  const notificationRender = () => {
    if (!isMountedRef.current) return null;
    return <ReactNotification ref={notificationDOMRef} />;
  };

  const errorModal = () => {
    if (!showErrorModal) return null;

    return (
      <ErrorModal
        title={trans(props.trans, "error.modal.title")}
        description={trans(props.trans, "error.modal.description")}
        action_text={trans(props.trans, "error.modal.action_text")}
      />
    );
  };

  const languageSection = () => {
    return (
      <section className="main-wrapper__inclusion-box">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--languages monserrat-medium pr sprite-b">
          {trans(props.trans, "settings.language_list.title")}
        </h2>

        <LanguageList
          classNames={{
            mainBox: "main-wrapper__list-out",
            list: "tab tab--languages-list tab--inline-languages-list",
            listItem: "tab__item",
            button: "tab__link sprite-b db pr tl sprite-a",
          }}
          lngText={{
            hy: trans(props.trans, "settings.language_list.prefix_hy"),
            ru: trans(props.trans, "settings.language_list.prefix_ru"),
            en: trans(props.trans, "settings.language_list.prefix_en"),
          }}
          setTranslationsAction={props.setTranslationsAction}
          updateAccount={props.updateAccount}
        />
      </section>
    );
  };

  const shortcuts = () => {
    const shortcutList = [1, 2, 3].map((item, index) => {
      return (
        <div className="main-wrapper__third-list-item ver-top-box" key={index}>
          <div
            className={`main-wrapper__third-list-switcher-box pr${
              item === props.parentState.cover
                ? " main-wrapper__third-list-switcher-box--active"
                : ""
            }`}
            onClick={() => {
              localStorageSetItem("profileCover", item);
              props.updateParentState({ cover: item });
            }}
          >
            <img
              className="main-wrapper__third-list-img"
              src={`${config.imgURLPrefix}img/cover-${item}.jpg`}
              alt={`Background ${item}`}
            />
            <div className="main-wrapper__third-list-switcher sprite-a center-center" />
          </div>
        </div>
      );
    });

    return (
      <div className="main-wrapper__inner-big">
        <section className="main-wrapper__services">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--shortcuts monserrat-medium pr sprite-b">
            {trans(props.trans, "settings.shortcuts.title")}
          </h2>
          <div className="main-wrapper__third-list main-wrapper__third-list--small-borders">
            {shortcutList}
          </div>
        </section>
      </div>
    );
  };
  return (
    <>
      {notificationRender()}
      <div className="main-wrapper__inner-left fl">
        {languageSection()}

        <section className="main-wrapper__inclusion-box">
          <div className="main-wrapper__sub-title main-wrapper__sub-title--notifications pr sprite-b">
            <h2 className="main-wrapper__sub-title-inner monserrat-medium">
              {trans(props.trans, "settings.notifications.title")}
            </h2>
            <p className="main-wrapper__sub-description fs14">
              {trans(props.trans, "settings.notifications.description")}
            </p>
          </div>

          <div className="main-wrapper__list-out">
            <ul className="list list--double list--notifications">
              <li className="list__item">
                <div className="list__link pr">
                  {trans(props.trans, "settings.notifications.sms_title")}
                  <div className="list__services-second">
                    <input
                      className="form__checkbox dn"
                      id="service-1"
                      name="service-1"
                      type="checkbox"
                      checked={notificationTypes.sms}
                      onChange={() => changeHandler("sms")}
                      disabled={notificationTypes["smsDisabled"]}
                    />
                    <label
                      className="form__check-label pa db"
                      htmlFor="service-1"
                    >
                      {" "}
                    </label>
                  </div>
                </div>
              </li>
              <li className="list__item">
                <div className="list__link pr">
                  {trans(props.trans, "settings.notifications.email_title")}
                  <div className="list__services-second">
                    <input
                      className="form__checkbox dn"
                      id="service-2"
                      name="service-2"
                      type="checkbox"
                      checked={notificationTypes.mail}
                      onChange={() => changeHandler("mail")}
                      disabled={notificationTypes["mailDisabled"]}
                    />
                    <label
                      className="form__check-label pa db"
                      htmlFor="service-2"
                    >
                      {" "}
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
      {shortcuts()}
      {errorModal()}
    </>
  );
}

export default Settings;